import React, { useEffect, useState } from "react";
import { formatarDia, formatarHora } from "../../services/conversaoTimer";
import ModalCheckinQrConteudo from "./modalCheckinQrConteudo";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaCheck,
  FaCheckDouble,
  FaQrcode,
} from "react-icons/fa";
import api from "../../services/axios";
import ModalPesquisa from "../../components/modal/modalPesquisa";
import { toast } from "react-toastify";

function obterSaidaAgenda(participante) {
  return participante?.saida_agenda || participante?.saidaAgenda || null;
}

function formatarDataHoraSaida(valor) {
  if (!valor) return "";
  const dia = formatarDia(valor);
  const hora = formatarHora(valor);
  if (!dia && !hora) return "";
  return `${dia}${hora ? ` ${hora.substring(0, 5)}` : ""}`.trim();
}

function LinhaAgendaConteudo(props) {
  const [showModalQr, setShowModalQr] = useState(false);
  const [showLinha, setShowLinha] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [showModalPesquisa, setShowModalPesquisa] = useState(false);
  const [pesquisa, setPesquisa] = useState(null);

  useEffect(() => {
    handleParticipantes();
  }, [showLinha, props.item]);

  useEffect(() => {
    setShowLinha(false);
  }, [props.item]);

  const handleParticipantes = () => {
    const lista = Array.isArray(props?.item?.participantes)
      ? [...props.item.participantes]
      : [];

    lista.sort((a, b) => {
      const nomeA = a?.usuario?.nome || "";
      const nomeB = b?.usuario?.nome || "";
      if (nomeA > nomeB) return 1;
      if (nomeA < nomeB) return -1;
      return 0;
    });

    setParticipantes(lista);
  };

  const handleModalPesquisa = () => {
    setShowModalPesquisa((prev) => !prev);
  };

  const abrirLeitorQr = () => {
    setShowModalQr(true);
  };

  const fecharLeitorQr = () => {
    setShowModalQr(false);
    props.handle?.();
  };

  /**
   * Ao clicar no convidado: abre modal de pesquisa só se houver pendência.
   * Sem pesquisa: apenas toaster, sem modal de PIN e sem recarregar a lista.
   */
  const verificaPesquisaUsuario = async (id) => {
    try {
      const resp = await api.post("/verifica-pesquisa-usuario", {
        id_usuario: id,
      });
      if (resp.status === 200) {
        if (resp.data.pesquisas?.length > 0) {
          setPesquisa(resp.data.pesquisas[0]);
          setShowModalPesquisa(true);
          return true;
        }

        toast.info("Nenhuma pesquisa pendente para este usuário");
        return false;
      }
    } catch (error) {
      console.log(error);
      toast.error("Erro ao verificar pesquisa pendente.");
    }
    return false;
  };

  const handleClickParticipante = async (ap) => {
    await verificaPesquisaUsuario(ap.id_usuario);
  };

  const handleLinha = () => {
    setShowLinha(!showLinha);
  };

  return (
    <>
      <ModalCheckinQrConteudo
        titulo="Check-in por QR"
        show={showModalQr}
        toggleModal={fecharLeitorQr}
        item={props.item}
        onCheckinConfirmado={() => props.handle?.()}
      />
      <ModalPesquisa
        titulo="Pesquisa"
        show={showModalPesquisa}
        toggleModal={handleModalPesquisa}
        pesquisa={pesquisa}
        tipoUsuario={"convidado"}
        texto={"Para liberar a entrada no proximo evento por favor nos diga o que achou"}
        close={true}
        onRespondido={() => props.handle?.()}
      />
      {props?.item ? (
        <div className={`linha-agenda`}>
          <div className={`d-flex`}>
            <div className={`area-texto-conteudo`}>
              {props.item.tipo !== "reuniao_negocio" ? (
                <div className="recepcao-linha-tipo">
                  <span>{props.item.tipo.replace("_", " ")}</span>
                  <span className="recepcao-qtd-participantes">
                    {props.item.participantes?.length || 0} participante
                    {(props.item.participantes?.length || 0) === 1 ? "" : "s"}
                  </span>
                </div>
              ) : (
                false
              )}
              <div className={`label-agenda`}>{`${props.item.nome}`}</div>
              <div className={`label-hora`}>
                {formatarHora(props.item.dt_hora_inicio).substring(0, 5)} -{" "}
                {formatarHora(props.item.dt_hora_fim).substring(0, 5)}
              </div>
            </div>
            <div className="recepcao-acoes-linha">
              <button
                type="button"
                className="apl-btn apl-btn--primary recepcao-btn-acao"
                onClick={abrirLeitorQr}
                title="Abrir leitor de QR Code"
              >
                <FaQrcode size={14} aria-hidden />
                QR Code
              </button>
              <button
                type="button"
                className="apl-btn apl-btn--secondary recepcao-btn-acao"
                onClick={() => handleLinha()}
              >
                {!showLinha ? (
                  <FaAngleDoubleDown size={14} aria-hidden />
                ) : (
                  <FaAngleDoubleUp size={14} aria-hidden />
                )}
                participantes
              </button>
            </div>
          </div>
          <div className={`area-participante ${showLinha ? "ativo" : ""}`}>
            <div className={`area-nome-evento`}>
              <h3>{props.item.participantes?.length || 0} Participantes</h3>
            </div>
            {participantes.length === 0 ? (
              <div className="linha-participante-conteudo">
                Nenhum participante cadastrado neste conteúdo.
              </div>
            ) : (
              participantes.map((ap, index) => {
                const saidaAgenda = obterSaidaAgenda(ap);
                const dataHoraSaida = formatarDataHoraSaida(saidaAgenda);

                return (
                  <div
                    key={ap.id || ap.id_usuario || index}
                    className={`linha-participante-conteudo`}
                    onClick={() => handleClickParticipante(ap)}
                  >
                    {saidaAgenda ? (
                      <div className="icone-check icone-check--saida" title="Saída registrada">
                        <FaCheckDouble />
                      </div>
                    ) : ap.presenca ? (
                      <div className="icone-check" title="Presença confirmada">
                        <FaCheck />
                      </div>
                    ) : (
                      false
                    )}
                    <span className="linha-participante-conteudo__nome">
                      {ap.usuario?.nome?.toUpperCase() || "—"}{" "}
                      <span style={{ color: "red", marginLeft: "8px" }}>
                        {ap.manual ? "(Manual)" : ""}
                      </span>
                    </span>
                    {dataHoraSaida ? (
                      <span className="linha-participante-conteudo__saida">
                        Saída: {dataHoraSaida}
                      </span>
                    ) : null}
                  </div>
                );
              })
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default LinhaAgendaConteudo;
